const loadState = {
  loading: false,
  loaded: false,
  awaitingLoaded: [],
};

let stripe;

const onloadCallback = () => {
  loadState.loaded = true;

  // Stripe now exists
  loadState.resolve = true;
};

const loadStripe = () => {
  // Set loading
  loadState.loading = true;

  const script = document.createElement('script');
  // Set the onload callback before the src as if the src is already set and the
  // script is cached it will never fire
  script.onload = onloadCallback;

  script.setAttribute(
    'src',
    'https://js.stripe.com/v3/',
  );
  script.type = 'text/javascript';
  script.async = true;
  script.defer = true;

  // Finally lets append it to the dom
  document.body.appendChild(script);
};

export default async () => {
  // If its not loading and its not loaded load the script
  if (loadState.loading === false && loadState.loaded === false) {
    const load = new Promise((resolve) => Object.defineProperty(loadState, 'resolve', {
      set() {
        const publishableKey = process.env.NODE_ENV === 'production'
          ? process.env.VUE_APP_LIVE_STRIPE_API_KEY
          : process.env.VUE_APP_TEST_STRIPE_API_KEY;

        // eslint-disable-next-line no-undef
        stripe = Stripe(publishableKey);
        loadState.awaitingLoaded.forEach((resolveAwaiting) => resolveAwaiting());
        resolve();
      },
    }));

    loadStripe();

    await load;
  }

  // If its not loaded await it being ready
  if (loadState.loading && loadState.loaded === false) {
    await new Promise((resolve) => loadState.awaitingLoaded.push(resolve));
  }

  // This should exist now
  return stripe;
};
